import React from 'react';
import {
  DragSourceAndDropTarget,
  DragAndDropSpace,
} from '../../components/DnDWrapper';
import Lightbox from 'react-images';

export const KeyplanContents = ({
  keyplans,
  values,
  errors,
  isSettingId,
  callbacks,
  canDrag,
  lightboxState,
  selectedLightboxImages,
}) => {
  const DndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return DndSpace(
    <div className='setting-main__table'>
      <table className='setting-table'>
        <thead className='setting-table__header'>
          <tr className='setting-table__label'>
            {canDrag && (
              <td className='value-table keyplan-value-table__drag'>
                <div className='value-table__label' />
              </td>
            )}
            <td className='value-table keyplan-value-table__status'>
              <div className='value-table__label'>ステータス</div>
            </td>
            <td className='value-table keyplan-value-table__name'>
              <div className='value-table__label'>名称</div>
            </td>
            <td className='value-table keyplan-value-table__menu'>
              <div className='value-table__label' />
            </td>
            <td className='value-table keyplan-value-table__image'>
              <div className='value-table__label' />
            </td>
          </tr>
        </thead>
        <tbody>
          {isSettingId === 0 ? (
            <KeyplanRegister
              key={0}
              values={values}
              errors={errors}
              callbacks={callbacks}
            />
          ) : null}
          {keyplans.map((keyplan, index) => {
            return isSettingId === keyplan.id ? (
              <KeyplanRegister
                key={keyplan.id}
                values={values}
                errors={errors}
                callbacks={callbacks}
              />
            ) : (
              <Keyplan
                index={index}
                keyplan={keyplan}
                callbacks={callbacks}
                canDrag={canDrag}
              />
            );
          })}
          {}
        </tbody>
      </table>
      {keyplans.length === 0 ? (
        <div className='table-has-no-data'>
          <div className='table-has-no-data__message'>
            現在登録されているデータがありません
          </div>
        </div>
      ) : null}
      <Lightbox
        images={selectedLightboxImages}
        width={'90%'}
        preventScroll={false}
        isOpen={lightboxState}
        onClose={callbacks.modal.handleCloseLightbox}
      />
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const getStatus = (keyplan, onChangeStatus) => {
  if (keyplan.display_flag === 1) {
    return <span className='setting-status-using'>使用中</span>;
  }
  return <span className='setting-status'>未使用</span>;
};

export const Keyplan = ({ keyplan, callbacks, canDrag, index }) => {
  const DndSrcTgt = element => {
    if (canDrag) {
      return (
        <DragSourceAndDropTarget
          id={`keyplanDnD`}
          index={index}
          data={keyplan}
          onBeginDrag={callbacks.dnd.onBeginDrag.bind(this)}
          onDropped={callbacks.dnd.onDropped.bind(this)}
          canDrag={true}
          canDrop={true}
        >
          {element}
        </DragSourceAndDropTarget>
      );
    }

    return element;
  };

  const substring = (str, num) => {
    if (typeof str === 'string' && str.length > num) {
      return `${str.substring(0, num)}...`;
    }
    return str;
  };

  return DndSrcTgt(
    <tr id={`keyplan-${keyplan.id}`} className='setting-table__item'>
      {canDrag && (
        <td className='keyplan-value-table__drag'>
          <button className='btn-icon--sm'>
            <i className='i-drag i-3x' />
          </button>
        </td>
      )}
      <td className='keyplan-value-table__status'>{getStatus(keyplan)}</td>
      <td className='keyplan-value-table__name'>
        <p>{substring(keyplan.comment, 10)}</p>
      </td>
      <td className='keyplan-value-table__menu'>
        <div className='setting-edit-btn'>
          <button
            className='btn--sm--stay'
            onClick={() => callbacks.form.setFormValues(keyplan, index)}
            style={{ display: canDrag ? 'none' : 'inline-block' }}
          >
            編集
          </button>
        </div>
      </td>
      <td className='keyplan-value-table__image' data-unlink>
        <div
          className='thumb-img'
          onClick={() => callbacks.modal.handleClickThumbnail(keyplan)}
        >
          <img src={keyplan.thumbnail_url} alt='' />
        </div>
      </td>
    </tr>
  );
};

const getErrorMessaage = (errors, column) => {
  if (errors[column]) {
    return <div className='validate-message show'>{errors[column]}</div>;
  } else {
    return null;
  }
};

export const KeyplanRegister = ({ values, errors, callbacks }) => (
  <tr id={`keyplan-register-${values.id}`} className='setting-table__item'>
    <td className='keyplan-value-table__status'>
      {values.id ? (
        <select
          name='display_flag'
          value={values.display_flag}
          onChange={e => callbacks.form.set(e)}
        >
          <option value='1'>使用中</option>
          <option value='0'>未使用</option>
        </select>
      ) : null}
    </td>
    <td className='keyplan-value-table__name'>
      <input
        type='text'
        name='comment'
        maxLength={512}
        className='keyplan-value-table__input'
        value={values.comment}
        onChange={e => callbacks.form.set(e)}
        onBlur={e => callbacks.form.validate(e)}
      />
      {getErrorMessaage(errors, 'comment')}
    </td>
    <td className='keyplan-value-table__menu'>
      <ul className='setting-edit-menu'>
        <li className='setting-edit-menu__item'>
          <button
            className='btn--sm--sub'
            onClick={callbacks.form.clearFormValues}
          >
            戻る
          </button>
        </li>
        <li className='setting-edit-menu__item'>
          <button
            className='btn--sm--effective'
            type='submit'
            disabled=''
            onClick={() => callbacks.form.submit(values)}
          >
            保存
          </button>
        </li>
      </ul>
    </td>
    <td className='keyplan-value-table__image'>
      <label htmlFor='image_url' className='input-setting-file'>
        <input
          id={'image_url'}
          name={'file_name'}
          type='file'
          style={{ display: 'none' }}
          onChange={e => callbacks.form.setImage(e.target)}
          onClick={e => {
            e.target.value = '';
          }}
          accept='image/png,image/jpeg,image/gif'
        />
        <img src={values.image_url} alt='' />
      </label>
      <label>
        <div className='validate-message show' style={{ textAlign: 'right' }}>
          {errors.image_url}
        </div>
      </label>
    </td>
  </tr>
);



// WEBPACK FOOTER //
// ./src/components/tables/Keyplan.jsx